module.exports = __webpack_public_path__ + "static/media/feature.87a6baff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/VanMasters/feature.jpg
// module id = 256
// module chunks = 0